var makeIcon = require('./makeIcon.js');
var makePin = require('./makePin.js');
var onMarkerClick = require('./onMarkerClick.js');

module.exports = function addMarkerToMap(map, item, i) {
	var iconOpts = {
		iconImageHref: makePin(item.color, '#FFF'),
		iconImageSize: [24, 24],
		iconImageOffset: [-12, -12]
	};

	if(item.img) {
		iconOpts = {
			iconImageHref: makeIcon(item.img, item.color, '#FFF'),
			iconImageSize: [44, 44],
			iconImageOffset: [-22, -22]
		}
	}


	var marker = new ymaps.Placemark([item.lat, item.lng], {
		hintContent: item.name
	}, iconOpts);
	marker.events.add('click', onMarkerClick.bind(marker, map, item))
	map.geoObjects.add(marker);
	item.marker = marker;

	return marker;
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/addMarkerToMap.js
 **/